import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IconEco } from '../../../../../../../../assets/icons/icon-eco';
import { isEcoPointsDemo } from '../../../../../../../../utils/helpers/demo';
import { ecoLevels, ecoLevelsState } from '../../utils';
import './index.scss';

type EcoStateProps = {
  value: number;
};

export const EcoState: React.FC<EcoStateProps> = ({ value }) => {
  const { t } = useTranslation('channel-details');

  const matchedEcoState = useMemo(
    () => ecoLevelsState.find((level) => value <= level.maxValue) || ecoLevelsState[0],
    [ecoLevels, value],
  );

  const ecoBoxStyle = useMemo(() => {
    return {
      '--background': matchedEcoState.value,
    } as React.CSSProperties;
  }, [matchedEcoState]);

  const iconStyle = useMemo(
    () =>
      ({
        '--stroke': '#FFFFFF',
      } as React.CSSProperties),
    [matchedEcoState],
  );

  return (
    <div className="eco-state">
      <div className="eco-state__heading">
        <p className="eco-state__heading--title">{t(matchedEcoState.heading)}</p>
        {isEcoPointsDemo && (
          <p className="eco-state__heading--subTitle">Zdobyłeś 750 punktów (jesteś lepszy niż 60% użytkowników)</p>
        )}
      </div>
      <div className="eco-state__eco" style={ecoBoxStyle}>
        {matchedEcoState.iconCount.map((value) => {
          return <IconEco key={value} style={iconStyle} />;
        })}
      </div>
    </div>
  );
};
